import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NCmsComponentHtml } from './cms-component-html.interface';

export const CMS_COMPONENT_HTML_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsComponentHtml.ID,
    isAdvanced: true,
    name: 'Free HTML',
    tags: ['text', 'html'],
    fields: [
        // general
    {
        type: NICmsContentField.EFieldType.label,
        key: 'section-general',
        title: 'General'
    },
    <NICmsContentField.IField>{
        key: 'text',
        type: NICmsContentField.EFieldType.textarea,
        title: 'Copy with HTML tags allowed',
        default: 'Lorem ipsum dolor',
        required: true
    }
    ]
};
